import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  RELOAD_ARTICLES: "relaod_articles",
  SET_ARTICLES_LOADED: "set_entries_loaded",
  CHANGE_INPUT_FILTER_ARTICLES: "change_input_filter_articles",
  ARTICLES_LOADED: "articles_loaded",
  RELOAD_ARTICLES_BY_FILTER: "reload_articles_by_filter",
};

export const INITIAL_STATE = {
  articles: {
    elements: [],
    status: STATUS_NOT_LOADED,
    filter: {
      name: null,
      reference: null,
      limit: 20,
      page: 1,
      sortBy: null,
      sortDir: null
    },
    rows: 0,
  },
};
export const articlesReducer = (state, action) => {
  const {
    RELOAD_ARTICLES,
    SET_ARTICLES_LOADED,
    CHANGE_INPUT_FILTER_ARTICLES,
    ARTICLES_LOADED,
    RELOAD_ARTICLES_BY_FILTER
  } = types;
  const { payload, type } = action;
  switch (type) {
    case RELOAD_ARTICLES:
      return {
        ...state,
        articles: { ...state.articles, status: STATUS_NOT_LOADED },
      };
    case SET_ARTICLES_LOADED:
      return {
        ...state,
        articles: {
          ...state.articles,
          status: LOADED,
          elements: action.payload,
        },
      };
    case ARTICLES_LOADED:
      return {
        ...state,
        articles: {
          ...state.articles,
          elements: payload.elements,
          status: LOADED,
          rows: payload.rows,
        },
      };
    case CHANGE_INPUT_FILTER_ARTICLES:
      return {
        ...state,
        articles: {
          ...state.articles,
          filter: {
            ...state.articles.filter,
            [payload.name]: payload.value,
          },
        },
      };
    case RELOAD_ARTICLES_BY_FILTER:
      return {
        ...state,
        articles: {
          ...state.articles,

          status: STATUS_NOT_LOADED,
          filter: {
            ...state.articles.filter,
            page: 1,
          },
        },
      };
    default:
      return state;
  }
};
